import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { FilterComponent } from '@ui/table-modifier/filters';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';
const noPrefix = '""';
const prefixSelectors = createAsyncSelectors((state) => state.core.dataSecurity.setupAuditTrail.sourceNamePrefix.get);
export const SourceNamePrefixFilter = (props) => {
    const { format, id, label, onChange, value } = props;
    const { data } = useAsyncState(prefixSelectors);
    const getSetupAuditTrailSourceNamePrefix = useAction(coreActions.requestGetCoreSetupAuditTrailSourceNamePrefix);
    const valueWithEmpty = value === null || value === void 0 ? void 0 : value.map((prefix) => (Number(prefix) === 0 ? noPrefix : prefix));
    useOnMount(() => {
        getSetupAuditTrailSourceNamePrefix();
    });
    const options = useMemo(() => {
        var _a;
        return (_a = data === null || data === void 0 ? void 0 : data.sourceNamespacePrefixes.map((prefix) => ({
            label: prefix ? prefix : COPY_SPECIFIC.NO_PREFIX,
            value: prefix ? prefix : noPrefix
        }))) !== null && _a !== void 0 ? _a : [];
    }, [data]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            value: options === null || options === void 0 ? void 0 : options.filter((option) => valueWithEmpty === null || valueWithEmpty === void 0 ? void 0 : valueWithEmpty.includes(option.value)).map((option) => option.label).join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), maxTagCount: 'responsive', mode: 'multiple', onChange: (prefixes) => {
                onChange({
                    [id]: {
                        format,
                        value: prefixes
                    }
                });
            }, options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(label), showArrow: true, value: valueWithEmpty })));
};
